import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocalisationService } from '../localisation.service';
import { Match } from '../match.model';
import { SPORTS } from '../sports';

/**
 * A pipe which transforms a [`Match`](../match.model.ts)
 * object into a boolean, representing whether the match only has pre-match coverage, eitner on a data level (i.e.
 * the object has an error in its `LiveData`) or on a client level (i.e. this client does not support live match
 * coverage for the match's sport).
 */
@Pipe({
  name: 'isPreMatchOnly',
  pure: false,
})
export class IsPreMatchOnlyPipe implements PipeTransform {

	constructor(private localisationService: LocalisationService) { }

	/**
	 * A pipe which transforms a [`Match`](../match.model.ts)
	 * object into a boolean, representing whether the match only has pre-match coverage, eitner on a data level (i.e.
	 * the object has an error in its `LiveData`) or on a client level (i.e. this client does not support live match
	 * coverage for the match's sport).
	 * @param match the `Match` object for the sporting match
	 * @returns `true` if either the match's live data has an error or the client does not support live predictions
	 * for the match's sport, otherwise `false`
	 */
	transform(match: Match): boolean {
		if (!match) {
			return true;
		}
		if (match.LiveData && match.LiveData.error) {
			return true;
		}
		const sportCode = match.MatchData.Sport.toUpperCase();
		return !this.localisationService.sportPrioritySort(SPORTS).some(s => s.code === sportCode && environment.liveCoverageSports.includes(sportCode));
	}

}
